// @flow
import type { ERROR_TYPE, ID_TYPE } from './common';

export type USER_TYPE = {
  id: ID_TYPE,
  profile_picture: string,
  email: string,
  result_type: string,
  first_name: string,
  last_name: string,
  phone: string,
  code: string,
  token: string,
  access_code?: string,
  license_type: string,
  profile_picture?: string,
};

export type USERS_FETCH_STARTED_TYPE = {
  type: 'USERS_FETCH_STARTED'
};
export const USERS_FETCH_STARTED = 'USERS_FETCH_STARTED';

export type USERS_FETCH_SUCCEED_TYPE = {
  type: 'USERS_FETCH_SUCCEED',
  payload: {
    entities: {[number]: USER_TYPE},
    order: Array<number>,
    page?: number,
    next?: number
  }
};
export const USERS_FETCH_SUCCEED = 'USERS_FETCH_SUCCEED';

export type USERS_FETCH_FAILED_TYPE = {
  type: 'USERS_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const USERS_FETCH_FAILED = 'USERS_FETCH_FAILED';

export type USER_FETCH_STARTED_TYPE = {
  type: 'USER_FETCH_STARTED',
  payload: number
};

export const USER_FETCH_STARTED = 'USER_FETCH_STARTED';

export type USER_FETCH_SUCCEED_TYPE = {
  type: 'USER_FETCH_SUCCEED',
  payload: USER_TYPE
};
export const USER_FETCH_SUCCEED = 'USER_FETCH_SUCCEED';

export type USER_FETCH_FAILED_TYPE = {
  type: 'USER_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const USER_FETCH_FAILED = 'USER_FETCH_FAILED';

export type USER_SELECTED_TYPE = {
  type: 'USER_SELECTED',
  payload: number
};
export const USER_SELECTED = 'USER_SELECTED';

export type USER_SELECTION_CLEARED_TYPE = {
  type: 'USER_SELECTION_CLEARED'
};
export const USER_SELECTION_CLEARED = 'USER_SELECTION_CLEARED';

export type ADD_USER_STARTED_TYPE = {
  type: 'ADD_USER_STARTED',
  payload: {
    result_type: string,
    first_name: string,
    last_name: string,
    phone: string,
    code: string,
    email: string
  }
};

export const ADD_USER_STARTED = 'ADD_USER_STARTED';

export type ADD_USER_SUCCEED_TYPE = {
  type: 'ADD_USER_SUCCEED',
  payload: USER_TYPE
}

export const ADD_USER_SUCCEED = 'ADD_USER_SUCCEED';

export type ADD_USER_FAILED_TYPE = {
  type: 'ADD_USER_FAILED',
  payload: ERROR_TYPE
}

export const ADD_USER_FAILED = 'ADD_USER_FAILED';

export type USER_ADDED_TYPE = {
  type: 'USER_ADDED',
  payload: USER_TYPE
};
export const USER_ADDED = 'USER_ADDED';

export type ADD_USER_CANCELED_TYPE = {
  type: 'ADD_USER_CANCELED',
};

export const ADD_USER_CANCELED = 'ADD_USER_CANCELED';

export type ADD_USER_ERROR_CLEARED_TYPE = {
  type: 'ADD_USER_ERROR_CLEARED',
};

export const ADD_USER_ERROR_CLEARED = 'ADD_USER_ERROR_CLEARED';

export type USER_FILTERS_CHANGED_TYPE = {
  type: 'USER_FILTERS_CHANGED',
  payload: {
    key: string,
    filter: string
  }
}

export const USER_FILTERS_CHANGED = 'USER_FILTERS_CHANGED';

export type REMOVE_USER_STARTED_TYPE = {
  type: 'REMOVE_USER_STARTED',
  payload: Object
};
export const REMOVE_USER_STARTED = 'REMOVE_USER_STARTED';

export type REMOVE_USER_SUCCEED_TYPE = {
  type: 'REMOVE_USER_SUCCEED',
  payload: number
}

export const REMOVE_USER_SUCCEED = 'REMOVE_USER_SUCCEED';

export type REMOVE_USER_FAILED_TYPE = {
  type: 'USER_REMOVED',
  payload: ERROR_TYPE
};

export const USER_REMOVED_FAILED = 'USER_REMOVED_FAILED';

export type CREATE_USERS_STEP_UPDATED_TYPE = {
  type: 'CREATE_USERS_STEP_UPDATED',
  payload: number
};

export type UPDATE_USER_STARTED_TYPE = {
  type: 'UPDATE_USER_STARTED',
  payload: Object
};
export const UPDATE_USER_STARTED = 'UPDATE_USER_STARTED';

export type UPDATE_USER_FAILED_TYPE = {
  type: 'UPDATE_USER_FAILED',
  payload: ERROR_TYPE,
}
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';


export type UPDATE_USER_SUCCEDED_TYPE = {
  type: 'UPDATE_USER_SUCCEDED',
  payload: USER_TYPE,
}
export const UPDATE_USER_SUCCEDED = 'UPDATE_USER_SUCCEDED';

export const CREATE_USERS_STEP_UPDATED = 'CREATE_USERS_STEP_UPDATED';

export type UPLOADING_USERS_STARTED_TYPE = {
  type: 'UPLOADING_USERS_STARTED',
  payload: {
    entities: {[number]: USER_TYPE},
    order: Array<number>
  }
}

export const UPLOADING_USERS_STARTED = 'UPLOADING_USERS_STARTED';

export type UPLOADING_USERS_ADDED_TYPE = {
  type: 'UPLOADING_USERS_ADDED',
  payload: {
    entities: {[number]: USER_TYPE},
    order: Array<number>
  }
};

export const UPLOADING_USERS_ADDED = 'UPLOADING_USERS_ADDED';

export type UPLOAD_USERS_STARTED_TYPE = {
  type: 'UPLOAD_USERS_STARTED',
  payload: {
    users: Array<USER_TYPE>
  }
}

export const UPLOAD_USERS_STARTED = 'UPLOAD_USERS_STARTED';

export type UPLOAD_USERS_SUCCEED_TYPE = {
  type: 'UPLOAD_USERS_SUCCEED'
};

export const UPLOAD_USERS_SUCCEED = 'UPLOAD_USERS_SUCCEED';

export type UPLOADING_USERS_CLEARED_TYPE = {
  type: 'UPLOADING_USERS_CLEARED'
}

export const UPLOADING_USERS_CLEARED = 'UPLOADING_USERS_CLEARED';


export type START_FETCH_USER_CODE_TYPE = {
  type: 'START_FETCH_USER_CODE',
  payload: Object,
}

export const START_FETCH_USER_CODE = 'START_FETCH_USER_CODE';


export type USER_ACTION_TYPE =
  | USER_FETCH_STARTED_TYPE
  | USER_FETCH_SUCCEED_TYPE
  | USER_FETCH_FAILED_TYPE
  | USER_SELECTED_TYPE
  | USER_ADDED_TYPE
  | USER_SELECTION_CLEARED_TYPE
  | ADD_USER_STARTED_TYPE
  | ADD_USER_SUCCEED_TYPE
  | START_FETCH_USER_CODE_TYPE
  | ADD_USER_FAILED_TYPE
  | ADD_USER_CANCELED_TYPE
  | ADD_USER_ERROR_CLEARED_TYPE
  | USER_FILTERS_CHANGED_TYPE
  | REMOVE_USER_STARTED_TYPE
  | REMOVE_USER_SUCCEED_TYPE
  | REMOVE_USER_FAILED_TYPE
  | CREATE_USERS_STEP_UPDATED_TYPE
  | UPLOADING_USERS_STARTED_TYPE
  | UPLOADING_USERS_CLEARED_TYPE
  | UPLOADING_USERS_ADDED_TYPE
  | UPLOAD_USERS_STARTED_TYPE
  | UPLOAD_USERS_SUCCEED_TYPE
  | USERS_FETCH_FAILED_TYPE
  | USERS_FETCH_SUCCEED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/users.js